//import polyfills; mainly needed for IE11 to work properly; features are used mostly by 3rd party libraries
import "react-app-polyfill/ie11"; //IE11: Promise, window.fetch, Object.assign, Symbol, Array.from (https://www.npmjs.com/package/react-app-polyfill
import "core-js/es/symbol/iterator"; //IE11: Symbol.iterator; react-app-polyfill doesn't contain this one (https://github.com/zloirock/core-js/blob/v3.6.4/packages/core-js/modules/es.symbol.iterator.js)
import "core-js/es/object/entries"; //IE11
import "core-js/es/object/values"; //IE11
import "core-js/es/reflect"; //IE11: Reflect (https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Reflect)
import "core-js/es/array/includes"; //IE11
import "core-js/es/array/find"; //IE11
import "core-js/es/array/find-index"; //IE11
import "core-js/es/array/index-of"; //IE11
import "core-js/es/string/starts-with"; //IE11
import "core-js/es/string/includes"; //IE11
import "core-js/es/string/repeat"; //IE11
import "core-js/features/dom-collections/for-each"; //IE11 - for mutationsObserver used in navbar2
import "core-js/es/map"; //IE10
import "core-js/es/weak-map"; //IE10
import "core-js/es/set"; //IE10

import { init } from "./init";

//IE10 only, remove when support for ie10 is deprecated
// import { intlPolyfill } from "./translations";

//support for older browsers (e.g. IE10), needs to be loaded before react-intl provider is initialized
// intlPolyfill();

window.recaptchaOptions = {
  useRecaptchaNet: true
};

init();
